import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, useNavigate } from "react-router-dom";
import { logoutIndex } from "../actions/AuthActions";
import Toast from "./Toast";

const ProtectedRoute = (props) => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        window.addEventListener('storage', e => {
            // 
            if (e.key === 'user' && e.oldValue && !e.newValue) {
                // store.dispatch(userSignOut());
                dispatch(logoutIndex());
            }
        });
    }, [])

    const checkUserToken = () => {
        const userToken = localStorage.getItem('user');
        if (!userToken) {
            setIsLoggedIn(false);
            Toast.fire({
                icon: 'error',
                title: 'Please Login First!'
            })
            return navigate('/');
        }
        setIsLoggedIn(true);
    }
    
    const user_permissions = JSON.parse(localStorage.getItem('perm'));
    const checkPermissions = () => {
        if (user_permissions && user_permissions.some(item => item.permission_id == props.children.props.requiredPermissionId)) {
            return props.children;
        } else {
            return navigate('/unauthorized');
        }
    }

    useEffect(() => {
        checkUserToken();
        checkPermissions();
    }, [isLoggedIn]);


    return (
        <React.Fragment>
            {
                isLoggedIn ? props.children : null
            }
        </React.Fragment>
    );
}
export default ProtectedRoute;